'use client';

import React, { useEffect } from 'react';

const Advertisement = () => {
    const hasAdData = process.env.NEXT_PUBLIC_ADSENSE_CLIENT_ID && process.env.NEXT_PUBLIC_ADSENSE_SLOT_ID;
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error('Adsense error', e);
        }
    }, []);

    if (!hasAdData) {
        return null;
    }

    return (
        <div className="border-2 border-solid" style={{ padding: '20px', textAlign: 'center' }}>
            <ins
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client={process.env.NEXT_PUBLIC_ADSENSE_CLIENT_ID}
                data-ad-slot={process.env.NEXT_PUBLIC_ADSENSE_SLOT_ID}
                data-ad-format="auto"
                data-full-width-responsive="true"
            ></ins>
        </div>
    );
};

export default Advertisement;
